import styled from '@emotion/styled';
import { Tag } from 'antd';

export const StatusTag = styled(Tag)`
  font-size: 12px;
  line-height: 28px;
  font-weight: ${props => props.theme.fontWeight.bolder};
  margin-left: ${props => props.theme.spacing.xs};
`;
